import fullScreenBlock from './fullscreen-block';
import animRounding from '../../helpers/anim-rounding';
import ScrollMagic from "scrollmagic";
import {PageEvent} from '~/pages/page.js';

export default class fullScreenBlockDesktop extends fullScreenBlock {

    _containerNavPosition = {
        top: 0,
        left: 0
    };

    _componentSize = {
        width: 0,
        height: 0
    };

    constructor(...args) {

        super(...args);

        this._isDesktop = ( ENV.device == 'desktop' );

        this._retrieveDOM();

    }

    _retrieveDOM() {

        this.dom.sliderContainer = this.dom.component.querySelector('.js-slider');
        this.dom.slides = this.dom.component.querySelectorAll('.js-slide');
        this.dom.mask = this.dom.component.querySelectorAll(".anim-mask");
        this.dom.images = this.dom.component.querySelectorAll(".anim-container .inner");
        this.dom.prev = this.dom.component.querySelector('.js-direction.prev');
        this.dom.next = this.dom.component.querySelector('.js-direction.next');
        // this.params.total = this.dom.images.length - 1;
        this.dom.containerNav = this.dom.component.querySelector('.js-container-nav');

        this._getPosElements();

        this.params = {
            canClick: true,
            current: 0,
            next: 0,
            total: this.dom.slides.length - 1,
            isSlider: (this.dom.sliderContainer)
        };

        this.dom.animate = {
            background : this.dom.component.querySelector('.js-anim-background'),
            mask : this.dom.component.querySelector('.js-anim-mask'),
            text : [].slice.call( this.dom.component.querySelectorAll('.js-anim-text') ),
        };

        if( this.dom.animate.mask ) {
            this._maskOpacity = parseFloat( this.dom.animate.mask.dataset.opacity );
        }
    }

    init() {
        super.init();

        this._initScrollAnim();
    }

    bind() {

        //Animation rounding
        this.animRounding = new animRounding({
            container: this.dom.slides,
            mask: this.dom.mask,
            inner: this.dom.images
        }, this.params.current, this._onComplete.bind(this));

        //Check if Slider exists and if Click is enable to Proceed the next Slide
        if( this.params.isSlider && this.params.canClick ){
            this.dom.prev.addEventListener("click", this._process.bind(this, "previous"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }

    }

    _initScrollAnim() {

        if( this._isDesktop )
            this._animBackground();
        this._animContent();
    }

    _process(direction){

        if( !this.params.canClick )
            return;

        this.params.canClick = false;
        //STEPS FORWARD
        if ( direction == "next" && this.params.current < this.params.total ) {
            this.params.next ++;
        }
        else if (direction == "next" && this.params.current == this.params.total) {
            this.params.next = 0;
        }
        //STEP BACKWARDS
        else if (direction == "previous" && this.params.current > 0) {
            this.params.next--;
        }
        else if (direction == "previous" && this.params.current == 0) {
            this.params.next = this.params.total;
        }

        // animation image
        this.animRounding.animate(this.params.next, this._containerNavPosition, this._componentSize);
    }

    _onComplete(indexCurrent) {
        this.params.current = indexCurrent;
        this.params.canClick = true;
    }

    _setSizeImg(){

        for (let i = 0; i < this.dom.slides.length; i++) {

            let widthImg = this.dom.slides[i].offsetWidth;
            let heightImg = this.dom.slides[i].offsetHeight;
            let image = this.dom.slides[i].querySelector('.inner');

            TweenLite.to(image,0 , {height: heightImg, width: widthImg, x: "-50%", y: "-50%"} );

        }

    }

    resize(width, height) {
        this._setSizeImg();
    }

    _animBackground() {

        // Create Tweenmax Animation
        let tweenBackground = new TimelineMax();
        if( this.dom.animate.background )
        tweenBackground
            .fromTo( this.dom.animate.background, 5, {scale: 1.15}, { scale: 1, ease: Power1.easeOut }, 'init')
        if( this.dom.animate.mask )
            tweenBackground.fromTo( this.dom.animate.mask, 2, {opacity: 0}, { opacity: this._maskOpacity, ease: Power1.easeOut }, 'init+=2')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            offset: -window.innerHeight / 2,
            duration: this.dom.component.offsetHeight * 1.5
        });
        scene.setTween( tweenBackground );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    _animContent() {

        let tweenContent = new TimelineMax();

        if( this.dom.animate.text.length > 0 )
            tweenContent
                .fromTo( this.dom.animate.text, 5,{y:300}, { y: '-50%', ease: Power4.easeOut })

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            duration: this.dom.component.offsetHeight
        });
        scene.setTween( tweenContent );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    resize(width, height) {
        super.resize(width, height);

        this._getPosElements();
    }

    _getPosElements() {

        this._componentSize = {
            top : this.dom.component.getBoundingClientRect().top,
            left : this.dom.component.getBoundingClientRect().left,
            width : this.dom.component.getBoundingClientRect().width,
            height : this.dom.component.getBoundingClientRect().height
        };

        if( this.dom.containerNav ) {
            this._containerNavPosition = {
                top : this.dom.containerNav.getBoundingClientRect().top + (this.dom.containerNav.getBoundingClientRect().height / 2),
                left : this.dom.containerNav.getBoundingClientRect().left + (this.dom.containerNav.getBoundingClientRect().width / 2)
            };
        }
    }

    /*
    init() {
    }

    unbind() {
    }
    resize(width, height) {
    }
    */
}




// WEBPACK FOOTER //
// src/js/components/fullscreen-block/fullscreen-block.desktop.js